import context from '@/context'
import { actionCreators as localizeActions } from '@/store/Localize'
import { startJwtMonitor } from '@/utils/auth'
import debug from 'debug'
import { setPermissions } from '@/store/Permissions'
import { redirectToReturnUrl } from '@/components/auth/authProvider'
import { push } from 'react-router-redux'

const log = debug('app:Identity')

const initialState = {
  user: null,
  // null = unknown (loading indicator)
  // true = user is signed in
  // false = login page should be displayed
  signedIn: null
}

const userFound = 'identity:userFound'
const userExpired = 'identity:userExpired'
const silentRenewError = 'identity:silentRenewError'
const userSignedOut = 'identity:userSignedOut'

const initEnv = (environment) => {
  if (environment) {
    context.environment = environment
    document.getElementById('root').classList.add(context.environment)
  }
}

export const actionCreators = {
  loadUser: () => {
    return function (dispatch) {
      return context.api.auth.userInfo() // todo local caching?
        .then(user => {
          initEnv(user.environment)
          if (user && user.sub) {
            const permissions = user.permissions
            delete user.permissions
            user.settings = typeof user.settings === 'string' ? JSON.parse(user.settings) : {}
            dispatch({ type: userFound, user: { profile: user } })
            if (typeof permissions === 'string') dispatch(setPermissions(permissions.split(','), user.institutionPermissions || null))
            startJwtMonitor()
            dispatch(localizeActions.loadResources())
            if (window.location.pathname === '/login') {
              redirectToReturnUrl()
            }
          } else {
            dispatch(actionCreators.userSignedOut())
          }
        }).catch(() => {
          dispatch(actionCreators.userSignedOut())
        })
    }
  },
  refresh: () => {
    return actionCreators.silentRefresh()
  },
  silentRefresh: () => (dispatch) => {
    return context.api.auth.refresh()
      .then(() => dispatch(actionCreators.loadUser()))
      .catch(e => log('JWT silent refresh failed. %o', e))
  },
  userExpired: () => {
    return { type: userExpired }
  },
  silentRenewError: (error) => {
    return { type: silentRenewError, error }
  },
  userSignedOut: (clean) => (dispatch) => {
    dispatch({ type: userSignedOut })
    if (clean) { dispatch(push('/login')) }
    dispatch(localizeActions.loadResources())
  },
  signOut: (clean) => (dispatch) => {
    context.api.auth.logout()
      .then(() => dispatch(actionCreators.userSignedOut(clean)))
      .catch(() => dispatch(actionCreators.userSignedOut(clean)))
  }
}

export function reducer (state = initialState, action) {
  switch (action.type) {
    case userExpired:
      return { ...state, signedIn: null }
    case silentRenewError:
    case userSignedOut:
      return { ...state, signedIn: false, user: null }
    case userFound:
      return { ...state, user: action.user, signedIn: true }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/Identity.js